export const getMinimumOrderQuantity = data => {
  if (!data || typeof data.minOrderQuantity !== 'number') {
    return '';
  }

  return data.minOrderQuantity.toString();
};
